import React from "react";

export default function CloseIcon({ width = "52", height = "52" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 52 52">
      <g
        id="Group_24410"
        data-name="Group 24410"
        transform="translate(-316 -127)"
      >
        <g transform="matrix(1, 0, 0, 1, 316, 127)" filter="url(#Ellipse_40)">
          <circle
            id="Ellipse_40-2"
            data-name="Ellipse 40"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 9)"
            fill="var(--primary-black)"
          />
        </g>
        <path
          id="Path_16222"
          data-name="Path 16222"
          d="M11.637,10.3,16.3,5.637,17.637,6.97,12.97,11.637,17.637,16.3,16.3,17.637,11.637,12.97,6.97,17.637,5.637,16.3,10.3,11.637,5.637,6.97,6.97,5.637Z"
          transform="translate(330.363 141.363)"
          fill="var(--white)"
        />
      </g>
    </svg>
  );
}
